
'use strict'

class Message {

    static success (message, sleep = 5){
        $('.topMessage').removeClass('error').addClass('success').addClass('show').find('p').text(message);
        if(Message.timeout){
            clearTimeout(Message.timeout);
        }
        Message.close(sleep);
    }

    static error (message, sleep = 5){
        $('.topMessage').addClass('error').removeClass('success').addClass('show').find('p').text(message);
        if(Message.timeout){
            clearTimeout(Message.timeout);
        }
        Message.close(sleep);
    }

    static close (sleep){
        Message.timeout = setTimeout(() => { 
            $('.topMessage').removeClass('error').removeClass('success').removeClass('show').find('p').text('');
        }, sleep * 1000);
    }

}

export default Message;
